/*
 * @Author       : zhangbobo01 zhangbobo01@baidu.com
 * @Date         : 2022-10-27 16:05:17
 * @LastEditors  : zhangbobo01 zhangbobo01@baidu.com
 * @LastEditTime : 2022-12-24 12:01:23
 * @FilePath     : /ticket-plat-frontend/src/router/convert/index.ts
 */
import _ from 'lodash';
import {Platform, RouterConfig, MobileRouterConfig, PcRouterConfig} from './routerConfig';

interface FormatParam {
    router: string;
    from: Platform;
    to: Platform;
}

export default class TicketRouterConvert {
    configs: {
        [propName: string]: RouterConfig;
    } = {
        [MobileRouterConfig.platform]: MobileRouterConfig,
        [PcRouterConfig.platform]: PcRouterConfig,
    };

    pathWhitelist: string[] = [];

    constructor(routerConfigs?: RouterConfig[]) {
        if (routerConfigs) {
            routerConfigs.forEach((config: RouterConfig) => {
                this.configs[config.platform] = config;
            });
        }
    }

    setPathWhitelist(pathWhitelist: string[]) {
        this.pathWhitelist = pathWhitelist;
    }

    formatToString(param: FormatParam): string | null {
        const fromUrlObj = new URL(param.router);

        // 路径映射
        const fromPath = fromUrlObj.hash.split('?')[0];
        if (this.pathWhitelist.length !== 0 && !this.pathWhitelist.includes(fromPath)) {
            // 非白名单内的路由不做转发
            return null;
        }
        const pathType = Object.keys(this.configs[param.from].path).find(
            (pathType: string) => this.configs[param.from].path[pathType] === fromPath
        );
        const toPath = _.get(this.configs, `${param.to}.path.${pathType}`, fromPath);

        // 路由参数映射
        let toParams: any = 'src=ticket&'; // OPT: 临时fixed 后续需要移动端配合修正
        (fromUrlObj.hash.split('?')[1] || '').split('&').forEach((paramPair: string) => {
            const [paramKey, paramValue] = paramPair.split('=');
            let currentParamType: any = '';
            _.forEach(this.configs[param.from].params, (paramType, fromParamKey) => {
                currentParamType = paramKey === fromParamKey ? paramType : currentParamType;
            });
            const toParamKey = _.get(this.configs, `${param.to}.params.${currentParamType}`, paramKey) as string;
            toParams += toParamKey ? `${toParamKey}=${paramValue || ''}&` : '';
        });

        return `
            ${this.configs[param.to].protocol}://
            ${this.configs[param.to].host}
            ${toPath}?
            ${toParams}
        `.replace(/\n\s*/g, '');
    }
}
